//import React from 'react';
import React, { useEffect, useRef } from 'react';
import '../App.css';
import './about.css';
import SEO from '../SEO';
import IntroVideo_about from '../images/pruple_line_field__small.mp4';
import VideoComponent from './VideoComponent.js';
import BGwordanimation4 from './BGwordanimation4.js';
//import Purple_poly from '../images/pruple_line_field__small.mp4'; 
import { useScrollBehavior } from './useScrollBehavior.js';
import { Link } from 'react-router-dom';
import Footer from './footer.js'


const About = () => {

 useScrollBehavior();

 const title = "About Yokai Software | Web Design, Development, and Digital Solutions";
const description = "Learn about Yokai Software and our approach to web design, web development, and digital solutions built for long-term business growth.";
const canonical = "https://yokaisoftware.com/about";
const image = "https://yokaisoftware.com/apple-touch-icon(1)_crow_logo.png";

const schema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://yokaisoftware.com/#organization",
      name: "Yokai Software",
      url: "https://yokaisoftware.com/",
      logo: "https://yokaisoftware.com/apple-touch-icon(1)_crow_logo.png",
      description:
        "Yokai Software provides web design, web development, SEO, and digital solutions for businesses."
    },
    {
      "@type": "WebPage",
      "@id": "https://yokaisoftware.com/about#webpage",
      url: "https://yokaisoftware.com/about",
      name: "About Yokai Software | Web Design, Development, and Digital Solutions",
      description:
        "Learn about Yokai Software and our approach to web design, web development, and digital solutions built for long-term business growth.",
      isPartOf: {
        "@id": "https://yokaisoftware.com/#website"
      },
      about: {
        "@id": "https://yokaisoftware.com/#organization"
      }
    }
  ]
};

  const stickyRef3 = useRef(null);
  const overlayRef3 = useRef(null);
  const stickyRef5 = useRef(null);
  const overlayRef5 = useRef(null);



useEffect(() => {
  const handleScroll10 = () => {
    const pairs = [
      { sticky: stickyRef3.current, overlay: overlayRef3.current },
      { sticky: stickyRef5.current, overlay: overlayRef5.current },
    ];

    for (const { sticky, overlay } of pairs) {
      if (!sticky || !overlay) continue;

      const stickyRect = sticky.getBoundingClientRect();
      const overlayRect = overlay.getBoundingClientRect();

      if (stickyRect.top <= 0 && stickyRect.bottom > overlayRect.height) {
        overlay.style.position = 'fixed';
        overlay.style.top = '0';
        // Optional: lock width while fixed so it doesn't shrink/expand
        // overlay.style.width = `${sticky.offsetWidth}px`;
      } else if (stickyRect.bottom <= overlayRect.height) {
        overlay.style.position = 'absolute';
        overlay.style.top = `${stickyRect.height - overlayRect.height}px`;
      } else {
        overlay.style.position = 'absolute';
        overlay.style.top = '0';
      }
    }
  };

  window.addEventListener('scroll', handleScroll10, { passive: true });
  handleScroll10(); // set initial positions on mount

  return () => window.removeEventListener('scroll', handleScroll10);
}, []);


  //useEffect(() => {
    //const handleScroll10 = () => {
      //const stickyRect3 = stickyRef3.current.getBoundingClientRect();
      //const overlayRect3 = overlayRef3.current.getBoundingClientRect();
      

      //if (stickyRect3.top <= 0 && stickyRect3.bottom > overlayRect3.height) {
        //overlayRef3.current.style.position = 'fixed';
        //overlayRef3.current.style.top = '0';
        /*overlayRef.current.style.width = `${stickyRef.current.offsetWidth}px`;*/
      //} else if (stickyRect3.bottom <= overlayRect3.height) {
        //overlayRef3.current.style.position = 'absolute';
        //overlayRef3.current.style.top = `${stickyRect3.height - overlayRect3.height}px`;
      //} else {
        //overlayRef3.current.style.position = 'absolute';
        //overlayRef3.current.style.top = '0';
      //}
    //};

    // ----- Block for ref5 -----
    //const stickyRect5 = stickyRef5.current.getBoundingClientRect();
    //const overlayRect5 = overlayRef5.current.getBoundingClientRect();

    //if (stickyRect5.top <= 0 && stickyRect5.bottom > overlayRect5.height) {
      //overlayRef5.current.style.position = 'fixed';
      //overlayRef5.current.style.top = '0';
    //} else if (stickyRect5.bottom <= overlayRect5.height) {
      //overlayRef5.current.style.position = 'absolute';
      //overlayRef5.current.style.top = `${stickyRect5.height - overlayRect5.height}px`;
    //} else {
      //overlayRef5.current.style.position = 'absolute';
      //overlayRef5.current.style.top = '0';
    //}
  

    //window.addEventListener('scroll', handleScroll10);

    //return () => {
      //window.removeEventListener('scroll', handleScroll10);
    //};
  //}, []);

  



  return (
    <div className="main_about-container">

      <SEO
      title={title}
      description={description}
      canonical={canonical}
      image={image}
      schema={schema}
    />
    
       {/*<div className="background-image"></div>*/}
     <VideoComponent  videoSrc={IntroVideo_about} />
       <div className='module_service_about' id='service_moduleOne_about'>
              
              <div id='about_heading1'>
                  <h1>Building for the Digital Age</h1>
                  <br></br>
                  <br></br>
                  <h3>Blending creativity and code to build websites, apps, and systems that last.</h3>
              </div>
       </div>
       <div className='module_service_about' id='service_moduleTwo_about'>
        <div id='mod2_div__about'>
          <h1>A Partnership</h1> 
          <h3>For The Digital Era</h3>
        </div>
        <div id='mod2_div__about2'>  
            <h3>
          <strong>Yokai Software and Web Development</strong> brings together creativity and engineering to deliver 
          digital solutions that truly perform. We specialize in building modern websites, scalable 
          applications, and full-stack systems that combine engaging design with reliable, optimized 
          code. Every project is approached with the same focus: create technology that's simple to 
          use, powerful behind the scenes, and tailored to the unique goals of each client. From 
          startups to established businesses, we partner closely to transform ideas into seamless, 
          high impact digital experiences.
          </h3>
        </div>
       </div>
       {/*<div class="svg-wrapper">
        <svg id='about_div1'  viewBox="0 0 94 94" preserveAspectRatio="xMidYMid meet">
          <rect x="-54" y="-5" width="200" height="100" rx="12" fill="none" stroke="#5112a3" stroke-width="15" />
            <foreignObject className="cutout-container">

              <div className='cutout'>

                  <p>This is space material </p>

              </div>

            </foreignObject>
        </svg>
      </div>*/}

      <div className='module_service_about' id='service_moduleThree_about'>
        <div id='mod3_div__about'>
          <h1>Enjoy Our Two Pricing Models.</h1>
          <h3>Professional & Partnership-Oriented</h3>
          <p>We become a natural extension of your team delivering web design, 
            development, and digital marketing services that scale with your business. 
            Whether you need a long-term partner or specialized support for a single 
            project, our approach is built to adapt to your goals.</p>
        </div>
      </div>

      <div className='module_service_about' id='service_moduleFour_about'>
        <div id='mod4_about_div1'>
          <div   className="sticky-element-container3 ">
            <div  ref={stickyRef3}className="background-div3">
              <div ref={overlayRef3} className="overlay-container3">
                <div id='about_overlayText3'>
                  <br></br>
                  <br></br>
                  <br></br>
                  <h1>Subscription Based</h1>
                    <p>Partner with us on a monthly basis and unlock the flexibility to scale. 
                    Whether you need end-to-end web, design, and marketing services or simply 
                    extra support where it counts, we adapt to your needs..</p>
                    <br></br>
                    <br></br>
                    <Link
                        to="/pricing#service_moduleFour_pricing"
                        className="mod1half_ctaPrimary2"
                      >View Pricing
                    </Link>
                    <br></br>
                    <br></br>
                </div>
                
        
              </div>
           </div>
         
          </div>
            <div id='mod4_about_div2'>
                <div id='about_pic_div1'></div>
            </div>
        </div>
    
   </div>
   <div className='module_service_about' id='service_moduleFive_about'>
      <div id='spacer_div_parralx'>
            <h1>Tailored for Your Business</h1>
          <h3>Because cookie-cutter doesn't cut it.</h3>
          <p>Your business is unique, your marketing should be too. 
            At Yokai Software, we create custom web, design, and 
            marketing solutions that highlight your strengths and 
            set you apart from the competition. No templates. 
            No shortcuts. Just strategies built for your goals.</p>
      </div> 
  </div> 
  <div className='module_service_about' id='service_moduleSix_about'>
        <div id='mod6_about_div1'>
           <div id='mod6_about_div2'>
                <div id='about_pic_div1_m6'></div>
            </div>
          <div   className="sticky-element-container3_m6 ">
            <div  ref={stickyRef5}className="background-div3_m6">
              <div ref={overlayRef5} className="overlay-container3_m6">
                <div id='about_overlayText3_m6'>
                  <br></br>
                  <br></br>
                  <br></br>
                  <h1>Project Based</h1>
                    <p>Whether it's a full website redesign or a one-off app feature, 
                      we work with you on clearly defined projects tailored to your goals.</p>
                      <br></br>
                    <br></br>
                    <Link
                        to="/pricing#service_moduleSix_pricing"
                        className="mod1half_ctaPrimary2"
                      >View Pricing
                    </Link>
                    <br></br>
                    <br></br>
                </div>
        
              </div>
           </div>
         
          </div>
           
        </div>
    
   </div>

 

   <div className='module_service_about' id='service_moduleSeven_about'>
      <div id='spacer_div_parralx2'>
           <BGwordanimation4/>
      </div> 
  </div>  

 
    <Footer/>
   
    </div>
  );
}

export default About;


/*<div className="module_service_about" id="modulePackages_service_about">
  				<div id="packages_container_service_about">
					<div className="package_box_service_about">
      					<h1>Starter</h1>
      					<h2>$199 <span>$398</span></h2>
							<ul>
        						<li>3 Page Website</li>
        						<li>3 Banner Design</li>
        						<li>5 Stock Photos</li>
        						<li>1 jQuery Slider Banner</li>
        						<li>FREE Google Friendly Sitemap</li>
        						<li>Complete W3C Certified HTML</li>
        						<li>48 to 72 hours TAT (Revision)</li>
        						<li>Social Media Integration</li>
        						<li>100% Ownership Rights</li>
        						<li>100% Satisfaction Guarantee</li>
        						<li>100% Unique Design Guarantee</li>
        						<li>100% Money Back Guarantee *</li>
      						</ul>
    				</div>
					<div className="package_box_service_about">
      					<h1>Professional</h1>
      					<h2>$399 <span>$798</span></h2>
      						<ul>
        						<li>5 Unique Pages Website</li>
        						<li>CMS / Admin Panel Support</li>
        						<li>8 Stock Images</li>
        						<li>5 Banner Designs</li>
        						<li>1 jQuery Slider Banner</li>
        						<li>FREE Google Friendly Sitemap</li>
        						<li>Complete W3C Certified HTML</li>
        						<li>48 to 72 hours TAT (Revision)</li>
        						<li>Social Media Integration</li>
        						<li>Complete Deployment</li>
        						<li>100% Ownership Rights</li>
        						<li>100% Satisfaction Guarantee</li>
        						<li>100% Unique Design Guarantee</li>
        						<li>100% Money Back Guarantee *</li>
       							 <li>Mobile Responsive Additional $200*</li>
      						</ul>
    				</div>
					<div className="package_box_service_about">
      					<h1>Business Web</h1>
      					<h2>$699 <span>$1398</span></h2>
							<ul>
        						<li>15 Unique Pages Website</li>
        						<li>CMS / Admin Panel Support</li>
        						<li>Unlimited Revisions</li>
        						<li>8 Stock Images</li>
        						<li>5 Banner Designs</li>
        						<li>1 jQuery Slider Banner</li>
        						<li>Online Payment Integration (Optional)</li>
        						<li>Appointment / Scheduling Integration (Optional)</li>
       							<li>Complete W3C Certified HTML</li>
        						<li>Complete Deployment</li>
        						<li>Social Media Integration</li>
        						<li>Mobile Responsive Website</li>
        						<li>Dedicated Account Manager</li>
        						<li>100% Satisfaction Guarantee</li>
        						<li>100% Unique Design Guarantee</li>
        						<li>100% Money Back Guarantee *</li>
      						</ul>
    				</div>
					<div className="package_box_service_about">
      					<h1>Startup E-Commerce</h1>
      					<h2>$699 <span>$1398</span></h2>
							<ul>
        						<li>Up to 15 Unique Pages Website</li>
        						<li>Dynamic Website</li>
        						<li>CMS</li>
        						<li>Mobile Responsive</li>
        						<li>Up To 100 Products</li>
        						<li>Unlimited Categories</li>
        						<li>Shopping Cart Integration</li>
        						<li>Payment Integration</li>
        						<li>Sales & Inventory Management</li>
        						<li>Free Google Friendly Sitemap</li>
        						<li>Complete Deployment</li>
        						<li>Dedicated Account Manager</li>
        						<li>100% Ownership Rights</li>
        						<li>100% Satisfaction Guarantee</li>
        						<li>100% Unique Design Guarantee</li>
        						<li>100% Money Back Guarantee</li>
      						</ul>
   					 </div>
					<div className="package_box_service_about">
      					<h1>Business E-Commerce</h1>
      					<h2>$899 <span>$1798</span></h2>
							<ul>
        						<li>Unlimited Pages</li>
        						<li>Unlimited Categories</li>
        						<li>Unlimited Revisions</li>
        						<li>Full Shopping Cart & Checkout</li>
        						<li>Sales & Inventory Management</li>
        						<li>CMS</li>
        						<li>Multi-lingual</li>
        						<li>Search Bar</li>
        						<li>Mobile Responsive</li>
        						<li>Free Google Friendly Sitemap</li>
        						<li>Search Engine Submission</li>
        						<li>Complete Deployment</li>
        						<li>Dedicated Account Manager</li>
        						<li>100% Ownership Rights</li>
        						<li>100% Satisfaction Guarantee</li>
        						<li>100% Unique Design Guarantee</li>
        						<li>100% Money Back Guarantee *</li>
      						</ul>
   					 </div>
					 <div className="package_box_service_about">
      					<h1>Enterprise</h1>
      					<h2>$1299 <span>$2598</span></h2>
							<ul>
        						<li>Unlimited Pages Website</li>
        						<li>Custom High-End Design</li>
        						<li>Custom WP or PHP Development</li>
        						<li>Unlimited Revisions</li>
        						<li>CMS</li>
        						<li>Online Payment Integration (Optional)</li>
        						<li>Multi Lingual (Optional)</li>
        						<li>Mobile Responsive</li>
        						<li>Free Google Friendly Sitemap</li>
        						<li>Search Engine Submission</li>
        						<li>Complete Deployment</li>
        						<li>Dedicated Account Manager</li>
        						<li>100% Ownership Rights</li>
        						<li>100% Satisfaction Guarantee</li>
        						<li>100% Unique Design Guarantee</li>
        						<li>100% Money Back Guarantee *</li>
      						</ul>	
    				</div>

  				</div>
			</div>  */